import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccountNav = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M12 10a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm4-6a6 6 0 1 0 0 12 6 6 0 0 0 0-12ZM7.156 22.146c.408-1.037 1.664-1.864 3.517-2.419 1.788-.536 3.836-.727 5.326-.727 1.49 0 3.538.191 5.327.727 1.853.555 3.109 1.382 3.517 2.419.038.097.046.22-.02.396-.07.186-.213.398-.417.592-4.711 4.476-12.103 4.476-16.814 0a1.662 1.662 0 0 1-.417-.592c-.065-.176-.058-.3-.02-.396ZM15.999 17c-1.622 0-3.874.204-5.9.811-1.962.588-4.037 1.651-4.805 3.603-.513 1.306.227 2.51.92 3.17 5.484 5.209 14.087 5.209 19.57 0 .694-.66 1.434-1.864.92-3.17-.768-1.952-2.843-3.015-4.804-3.603C19.873 17.204 17.622 17 16 17Z",
		clipRule: "evenodd"
	})
});
export default SvgAccountNav;
